export function dispatchNoticeText(notices = [], total = notices.length) {
  const plates = [...new Set(notices.map(row => row.plate).filter(Boolean))]
  if (!total) return ''
  const latest = plates.length ? `最新派单：${plates.join('、')}，` : ''
  return `${latest}今天共计派单${total}单，请当天联系客户`
}

export function noticeMotion(contentWidth, availableWidth) {
  const distance = Math.max(0, Math.ceil(contentWidth - availableWidth))
  return { distance, duration: Math.max(8, distance / 24 + 4) }
}

export function watchDispatchNotices({
  load, publish, agentId, documentTarget = document, windowTarget = window,
  schedule = setInterval, unschedule = clearInterval,
}) {
  let alive = true, busy = false
  const refresh = async () => {
    if (!alive || busy || documentTarget.hidden) return
    busy = true
    try {
      const result = await load()
      if (alive) publish(result?.agentId === agentId ? result : { available: false, notices: [] })
    } catch {
      if (alive) publish({ available: false, notices: [] })
    } finally { busy = false }
  }
  refresh()
  // Dispatch writes a local journal, not the conversation change bus.
  const timer = schedule(refresh, 30000)
  documentTarget.addEventListener('visibilitychange', refresh)
  windowTarget.addEventListener('focus', refresh)
  windowTarget.addEventListener('online', refresh)
  return () => {
    alive = false
    unschedule(timer)
    documentTarget.removeEventListener('visibilitychange', refresh)
    windowTarget.removeEventListener('focus', refresh)
    windowTarget.removeEventListener('online', refresh)
  }
}
